import React from 'react'

import '../../../assets/css/footer.css'

const Footer = () => {
    return (
        <>
            <div className="container-fluid footer-container">
				<div className="container">
					<div className="row align-items-center">
						<div className="col">
							Copyright © 2021 - <span className="title accent-text">
								HuluTani Team
							</span>
						</div>
					</div>
				</div>
			</div>     
        </>
    )
}

export default Footer
